import { z } from "zod";
export const OptionSchema = z.object({
    value: z.string(),
    label: z.string(),
});
export const FieldTypeSchema = z.enum([
    "text",
    "textarea",
    "email",
    "phone",
    "number",
    "date",
    "select",
    "checkbox",
    "radio",
    "file",
]);
export const BaseFieldSchema = z.object({
    id: z.string(),
    label: z.string().optional(),
    type: FieldTypeSchema,
    required: z.boolean().optional(),
    placeholder: z.string().optional(),
    helpText: z.string().optional(),
});
export const SelectLikeFieldSchema = BaseFieldSchema.extend({
    type: z.enum(["select", "radio"]),
    options: z.array(OptionSchema).optional(),
    multiple: z.boolean().optional(),
});
export const FileFieldSchema = BaseFieldSchema.extend({
    type: z.literal("file"),
    accept: z.string().optional(),
    maxSizeMb: z.number().optional(),
    multiple: z.boolean().optional(),
});
export const CheckboxFieldSchema = BaseFieldSchema.extend({
    type: z.literal("checkbox"),
});
export const TextualFieldSchema = BaseFieldSchema.extend({
    type: z.enum(["text", "email", "phone", "number", "date", "textarea"]),
});
export const FormFieldSchema = z.discriminatedUnion("type", [
    SelectLikeFieldSchema,
    FileFieldSchema,
    CheckboxFieldSchema,
    TextualFieldSchema,
]);
export const FormSectionSchema = z.object({
    id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    fields: z.array(FormFieldSchema),
});
export const FormConfigSchema = z.object({
    id: z.string(),
    org: z.string(),
    slug: z.string(),
    title: z.string(),
    sections: z.array(FormSectionSchema),
    submitButtonText: z.string().optional(),
    successMessage: z.string().optional(),
    redirectUrl: z.string().optional(),
});
export const PresignRequestSchema = z.object({
    fieldId: z.string(),
    fileName: z.string(),
    contentType: z.string(),
    size: z.number().int().nonnegative(),
});
export const PresignResponseSchema = z.object({
    url: z.string().url(),
    fields: z.record(z.string(), z.string()).optional(),
    headers: z.record(z.string(), z.string()).optional(),
});
export const SubmitFormBodySchema = z.object({
    formId: z.string(),
    data: z.record(z.string(), z.unknown()),
});
export const FileStatusSchema = z.object({
    id: z.string(),
    status: z.enum(["pending_scan", "clean", "infected", "quarantined"]),
    updatedAt: z.string().datetime().optional(),
    scanTag: z.string().optional(),
});
